<template>
  <div>
    <PriceBar />
    <nuxt />
    <!-- TODO #1 good idea to move this into the page not layout -->
    <nav class="navbar">
      <div class="is-flex quote-summary-container">
        <button
          v-if="$store.getters['user/userEmail'] !== 'anonymous@pedalsure.com'"
          class="button is-outlined is-fullwidth mr-2"
          @click="sendEmail"
        >
          <span> Email quote </span>
        </button>

        <button
          :class="{
            'is-loading':
              $store.getters['quote/isPriceLoading'] ||
              $store.getters['quote/isQuoteLoading'],
          }"
          class="button ps-button is-fullwidth"
          data-test="summary-buy-now"
          @click="continueToDetails"
        >
          <span> Buy now </span>
        </button>
      </div>
    </nav>
    <BikeAddModal />
    <EditBikeModal />
    <EmailModal />
    <BuildBadge />
  </div>
</template>

<script>
/* eslint-disable no-console */
import { mapActions, mapGetters } from 'vuex'
import PriceBar from '@/components/quote/PriceBar'
import BikeAddModal from '@/components/modals/BikeAdd'
import EditBikeModal from '@/components/modals/EditBike'
import EmailModal from '@/components/modals/Email'
import BuildBadge from '@/components/common/BuildBadge'

import { buildSeoHead } from '@/helpers/seo'

export default {
  components: {
    BuildBadge,
    PriceBar,
    BikeAddModal,
    EditBikeModal,
    EmailModal,
  },
  middleware: ['load-public-quote'],
  data() {
    return {}
  },
  // TODO #1 good idea to move this into the page not layout
  head() {
    return {
      // Canonical (and noindex where the route has no search value) for every
      // page using this layout — see helpers/seo.js.
      ...buildSeoHead(this.$route.path),
      style: [
        { cssText: this.$store.getters['theme/theme'], type: 'text/css' },
      ],
    }
  },
  computed: {
    ...mapGetters({
      sendQuoteEmailSuccess: 'quote/sendQuoteEmailSuccess',
    }),
  },
  mounted() {
    this.$store.dispatch('quote/setMtaFlag', false)
  },
  methods: {
    ...mapActions('quote', {
      sendQuoteEmail: 'sendQuoteEmail',
      syncPublicQuote: 'syncPublicQuote',
    }),
    async sendEmail() {
      await this.sendQuoteEmail(this.$route.params.quoteid)
      if (this.sendQuoteEmailSuccess) {
        this.$modal.show('email-modal', {
          message: 'Email sent!',
          description: 'We’ve sent your quotation to your email.',
        })
      }
    },
    async continueToDetails() {
      await this.syncPublicQuote()
      this.$router.push({
        path: `/quote/${this.$route.params.quoteid}/details`,
        query: { ...this.$route.query },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.navbar {
  padding: 15px 0;
  max-width: 560px;
  margin: 0 auto;

  .button-container {
    margin: 0 auto;
    width: 100%;
    .column {
      margin: 0 5px;
    }
    .button {
      width: 100%;
      border-radius: 15px;
      @include desktop {
        max-width: 245px;
      }
    }
  }
}
.quote-summary-container {
  padding: 0 10px;
  width: 100%;
  @include tablet {
    padding: 0;
  }
}
</style>
